import { t } from "ttag";

import { useCountAdminPersonalAccessTokensQuery } from "metabase/api";

import { AuthCardBody } from "./AuthCard/AuthCard";

export const PersonalAccessTokensAuthCard = () => {
  const { data } = useCountAdminPersonalAccessTokensQuery();
  const tokenCount = data ?? 0;
  const isConfigured = tokenCount > 0;

  return (
    <AuthCardBody
      type="personal-access-tokens"
      title={t`Personal Access Tokens`}
      description={t`Manage user-owned tokens for programmatic API access.`}
      isConfigured={isConfigured}
      isEnabled
      badgeText={
        tokenCount === 1 ? t`1 active token` : t`${tokenCount} active tokens`
      }
      buttonText={isConfigured ? t`Manage` : t`Set up`}
    />
  );
};
